export const LOGO_URL = "https://customer-assets.emergentagent.com/job_driving-school-b/artifacts/ysn7vbog_Logo%20_%20BIU%20BIU%20DRIVING.jpg";

export const MANUAL_CAR_IMAGES = [
  "https://customer-assets.emergentagent.com/job_driving-school-b/artifacts/yofgzz12_20241023_142952.jpg",
  "https://customer-assets.emergentagent.com/job_driving-school-b/artifacts/vmnvkicc_20241023_143635.jpg",
  "https://customer-assets.emergentagent.com/job_driving-school-b/artifacts/octeipgs_20241023_144116.jpg",
  "https://customer-assets.emergentagent.com/job_driving-school-b/artifacts/1uutj7g9_20241025_121044.jpg",
  "https://customer-assets.emergentagent.com/job_driving-school-b/artifacts/f40qachy_20241025_144715.jpg",
];

export const AUTOMATIC_CAR_IMAGES = [
  "https://customer-assets.emergentagent.com/job_driving-school-b/artifacts/8qkihz3w_Toyota%20Corolla%202020%20Hybrid%20Automata_g0.jpg",
  "https://customer-assets.emergentagent.com/job_driving-school-b/artifacts/8xr78rdv_Toyota%20Corolla%202020%20Hybrid%20Automata_g1.jpg",
  "https://customer-assets.emergentagent.com/job_driving-school-b/artifacts/hnbupv1c_Toyota%20Corolla%202020%20Hybrid%20Automata_g2.jpg",
  "https://customer-assets.emergentagent.com/job_driving-school-b/artifacts/wmgqph1t_Toyota%20Corolla%202020%20Hybrid%20Automata_g3.jpg",
];

export const HERO_SLIDES = [
  {
    src: "https://customer-assets.emergentagent.com/job_driving-school-b/artifacts/yofgzz12_20241023_142952.jpg",
    plate: "BV 60 BIU",
    title: "Suzuki S-Cross 2024",
    tag: "MANUALĂ",
    sub: "Categoria B",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_driving-school-b/artifacts/8xr78rdv_Toyota%20Corolla%202020%20Hybrid%20Automata_g1.jpg",
    plate: "BV 63 BIU",
    title: "Toyota Corolla 2020",
    tag: "AUTOMATĂ",
    sub: "Categoria B",
  },
];

export const HERO_BG = "https://static.prod-images.emergentagent.com/jobs/f28bb03d-b89a-4db4-8818-19e7031bef38/images/695b8379abe65d80fe8b9250789966cb093864f16bf8d6ae87eb25d0f51ed002.png";
export const ABOUT_IMG = "https://static.prod-images.emergentagent.com/jobs/f28bb03d-b89a-4db4-8818-19e7031bef38/images/62d3767f1419a5ea88cfbf28fb9a65ebd993d92d9c124a021cece6ab97a45bdb.png";

export const PHONE = "0723 88 66 88";
export const PHONE_TEL = "+40723886688";
export const EMAIL = "biubiudriving@gmail.com";
export const ADDRESS = "Hârseni - Sebeș nr. 94, Mândra, jud. Brașov";
export const FACEBOOK_URL = "https://www.facebook.com/profile.php?id=61567094370681&locale=ro_RO";
export const MEDICAL_LIST_PDF = "https://customer-assets.emergentagent.com/job_driving-school-b/artifacts/vadqrykh_Lista-unitati-medicale-permise_judetul%20Brasov.pdf";
export const ENROLLMENT_FORM_PDF = "https://customer-assets.emergentagent.com/job_driving-school-b/artifacts/92hnbjza_FISA%20DE%20INSCRIERE_CERERE_%20scoala%20de%20soferi%20BIU%20BIU%20DRIVING%20SRL.pdf";
export const CAZIER_BRASOV_URL = "https://bv.politiaromana.ro/ro/informatii-publice/serviciul-cazier-judiciar";
